function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import { utils as utils_exports, DEFAULTS, registerButton, TypedEvent, AbstractButton, events as events_exports$1, AbstractConfigurablePlugin, PSVError, CONSTANTS as constants_exports } from '../core/index.module.js';
import { Vector3, TextureLoader, MathUtils, MeshBasicMaterial, PlaneGeometry, Mesh, Group } from '../../three/build/three.module.js';

/*!
 * PhotoSphereViewer.MarkersPlugin 5.1.0
 * @copyright 2023 Damien "Mistic" Sorel
 * @licence MIT (https://opensource.org/licenses/MIT)
 */
var __defProp = Object.defineProperty;
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};

// src/events.ts
var events_exports = {};
__export(events_exports, {
  EnterMarkerEvent: function EnterMarkerEvent() {
    return _EnterMarkerEvent2;
  },
  GotoMarkerDoneEvent: function GotoMarkerDoneEvent() {
    return _GotoMarkerDoneEvent2;
  },
  HideMarkersEvent: function HideMarkersEvent() {
    return _HideMarkersEvent2;
  },
  LeaveMarkerEvent: function LeaveMarkerEvent() {
    return _LeaveMarkerEvent2;
  },
  MarkerVisibilityEvent: function MarkerVisibilityEvent() {
    return _MarkerVisibilityEvent2;
  },
  MarkersPluginEvent: function MarkersPluginEvent() {
    return _MarkersPluginEvent;
  },
  RenderMarkersListEvent: function RenderMarkersListEvent() {
    return _RenderMarkersListEvent2;
  },
  SelectMarkerEvent: function SelectMarkerEvent() {
    return _SelectMarkerEvent2;
  },
  SelectMarkerListEvent: function SelectMarkerListEvent() {
    return _SelectMarkerListEvent2;
  },
  SetMarkersEvent: function SetMarkersEvent() {
    return _SetMarkersEvent2;
  },
  ShowMarkersEvent: function ShowMarkersEvent() {
    return _ShowMarkersEvent2;
  },
  UnselectMarkerEvent: function UnselectMarkerEvent() {
    return _UnselectMarkerEvent2;
  }
});
var _MarkersPluginEvent = /*#__PURE__*/function (_TypedEvent) {
  _inherits(_MarkersPluginEvent, _TypedEvent);
  var _super = _createSuper(_MarkersPluginEvent);
  function _MarkersPluginEvent() {
    _classCallCheck(this, _MarkersPluginEvent);
    return _super.apply(this, arguments);
  }
  return _createClass(_MarkersPluginEvent);
}(TypedEvent);
var _MarkerVisibilityEvent = /*#__PURE__*/function (_MarkersPluginEvent2) {
  _inherits(_MarkerVisibilityEvent, _MarkersPluginEvent2);
  var _super2 = _createSuper(_MarkerVisibilityEvent);
  function _MarkerVisibilityEvent(marker, visible) {
    var _this;
    _classCallCheck(this, _MarkerVisibilityEvent);
    _this = _super2.call(this, _MarkerVisibilityEvent.type);
    _this.marker = marker;
    _this.visible = visible;
    return _this;
  }
  return _createClass(_MarkerVisibilityEvent);
}(_MarkersPluginEvent);
var _MarkerVisibilityEvent2 = _MarkerVisibilityEvent;
_MarkerVisibilityEvent2.type = "marker-visibility";
var _GotoMarkerDoneEvent = /*#__PURE__*/function (_MarkersPluginEvent3) {
  _inherits(_GotoMarkerDoneEvent, _MarkersPluginEvent3);
  var _super3 = _createSuper(_GotoMarkerDoneEvent);
  function _GotoMarkerDoneEvent(marker) {
    var _this2;
    _classCallCheck(this, _GotoMarkerDoneEvent);
    _this2 = _super3.call(this, _GotoMarkerDoneEvent.type);
    _this2.marker = marker;
    return _this2;
  }
  return _createClass(_GotoMarkerDoneEvent);
}(_MarkersPluginEvent);
var _GotoMarkerDoneEvent2 = _GotoMarkerDoneEvent;
_GotoMarkerDoneEvent2.type = "goto-marker-done";
var _LeaveMarkerEvent = /*#__PURE__*/function (_MarkersPluginEvent4) {
  _inherits(_LeaveMarkerEvent, _MarkersPluginEvent4);
  var _super4 = _createSuper(_LeaveMarkerEvent);
  function _LeaveMarkerEvent(marker) {
    var _this3;
    _classCallCheck(this, _LeaveMarkerEvent);
    _this3 = _super4.call(this, _LeaveMarkerEvent.type);
    _this3.marker = marker;
    return _this3;
  }
  return _createClass(_LeaveMarkerEvent);
}(_MarkersPluginEvent);
var _LeaveMarkerEvent2 = _LeaveMarkerEvent;
_LeaveMarkerEvent2.type = "leave-marker";
var _EnterMarkerEvent = /*#__PURE__*/function (_MarkersPluginEvent5) {
  _inherits(_EnterMarkerEvent, _MarkersPluginEvent5);
  var _super5 = _createSuper(_EnterMarkerEvent);
  function _EnterMarkerEvent(marker) {
    var _this4;
    _classCallCheck(this, _EnterMarkerEvent);
    _this4 = _super5.call(this, _EnterMarkerEvent.type);
    _this4.marker = marker;
    return _this4;
  }
  return _createClass(_EnterMarkerEvent);
}(_MarkersPluginEvent);
var _EnterMarkerEvent2 = _EnterMarkerEvent;
_EnterMarkerEvent2.type = "enter-marker";
var _SelectMarkerEvent = /*#__PURE__*/function (_MarkersPluginEvent6) {
  _inherits(_SelectMarkerEvent, _MarkersPluginEvent6);
  var _super6 = _createSuper(_SelectMarkerEvent);
  function _SelectMarkerEvent(marker, doubleClick, rightClick) {
    var _this5;
    _classCallCheck(this, _SelectMarkerEvent);
    _this5 = _super6.call(this, _SelectMarkerEvent.type);
    _this5.marker = marker;
    _this5.doubleClick = doubleClick;
    _this5.rightClick = rightClick;
    return _this5;
  }
  return _createClass(_SelectMarkerEvent);
}(_MarkersPluginEvent);
var _SelectMarkerEvent2 = _SelectMarkerEvent;
_SelectMarkerEvent2.type = "select-marker";
var _SelectMarkerListEvent = /*#__PURE__*/function (_MarkersPluginEvent7) {
  _inherits(_SelectMarkerListEvent, _MarkersPluginEvent7);
  var _super7 = _createSuper(_SelectMarkerListEvent);
  function _SelectMarkerListEvent(marker) {
    var _this6;
    _classCallCheck(this, _SelectMarkerListEvent);
    _this6 = _super7.call(this, _SelectMarkerListEvent.type);
    _this6.marker = marker;
    return _this6;
  }
  return _createClass(_SelectMarkerListEvent);
}(_MarkersPluginEvent);
var _SelectMarkerListEvent2 = _SelectMarkerListEvent;
_SelectMarkerListEvent2.type = "select-marker-list";
var _UnselectMarkerEvent = /*#__PURE__*/function (_MarkersPluginEvent8) {
  _inherits(_UnselectMarkerEvent, _MarkersPluginEvent8);
  var _super8 = _createSuper(_UnselectMarkerEvent);
  function _UnselectMarkerEvent(marker) {
    var _this7;
    _classCallCheck(this, _UnselectMarkerEvent);
    _this7 = _super8.call(this, _UnselectMarkerEvent.type);
    _this7.marker = marker;
    return _this7;
  }
  return _createClass(_UnselectMarkerEvent);
}(_MarkersPluginEvent);
var _UnselectMarkerEvent2 = _UnselectMarkerEvent;
_UnselectMarkerEvent2.type = "unselect-marker";
var _HideMarkersEvent = /*#__PURE__*/function (_MarkersPluginEvent9) {
  _inherits(_HideMarkersEvent, _MarkersPluginEvent9);
  var _super9 = _createSuper(_HideMarkersEvent);
  function _HideMarkersEvent() {
    _classCallCheck(this, _HideMarkersEvent);
    return _super9.call(this, _HideMarkersEvent.type);
  }
  return _createClass(_HideMarkersEvent);
}(_MarkersPluginEvent);
var _HideMarkersEvent2 = _HideMarkersEvent;
_HideMarkersEvent2.type = "hide-markers";
var _SetMarkersEvent = /*#__PURE__*/function (_MarkersPluginEvent10) {
  _inherits(_SetMarkersEvent, _MarkersPluginEvent10);
  var _super10 = _createSuper(_SetMarkersEvent);
  function _SetMarkersEvent(markers) {
    var _this8;
    _classCallCheck(this, _SetMarkersEvent);
    _this8 = _super10.call(this, _SetMarkersEvent.type);
    _this8.markers = markers;
    return _this8;
  }
  return _createClass(_SetMarkersEvent);
}(_MarkersPluginEvent);
var _SetMarkersEvent2 = _SetMarkersEvent;
_SetMarkersEvent2.type = "set-markers";
var _ShowMarkersEvent = /*#__PURE__*/function (_MarkersPluginEvent11) {
  _inherits(_ShowMarkersEvent, _MarkersPluginEvent11);
  var _super11 = _createSuper(_ShowMarkersEvent);
  function _ShowMarkersEvent() {
    _classCallCheck(this, _ShowMarkersEvent);
    return _super11.call(this, _ShowMarkersEvent.type);
  }
  return _createClass(_ShowMarkersEvent);
}(_MarkersPluginEvent);
var _ShowMarkersEvent2 = _ShowMarkersEvent;
_ShowMarkersEvent2.type = "show-markers";
var _RenderMarkersListEvent = /*#__PURE__*/function (_MarkersPluginEvent12) {
  _inherits(_RenderMarkersListEvent, _MarkersPluginEvent12);
  var _super12 = _createSuper(_RenderMarkersListEvent);
  function _RenderMarkersListEvent(markers) {
    var _this9;
    _classCallCheck(this, _RenderMarkersListEvent);
    _this9 = _super12.call(this, _RenderMarkersListEvent.type);
    _this9.markers = markers;
    return _this9;
  }
  return _createClass(_RenderMarkersListEvent);
}(_MarkersPluginEvent);
var _RenderMarkersListEvent2 = _RenderMarkersListEvent;
_RenderMarkersListEvent2.type = "render-markers-list";

// src/icons/pin.svg
var pin_default = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="10 9 81 81"><path fill="currentColor" d="M50.5 90S22.9 51.9 22.9 36.6 35.2 9 50.5 9s27.6 12.4 27.6 27.6S50.5 90 50.5 90zm0-66.3c-6.1 0-11 4.9-11 11s4.9 11 11 11 11-4.9 11-11-4.9-11-11-11z"/><!--Created by Rohith M S from the Noun Project--></svg>\n';

// src/MarkersButton.ts
var MarkersButton = /*#__PURE__*/function (_AbstractButton) {
  _inherits(MarkersButton, _AbstractButton);
  var _super13 = _createSuper(MarkersButton);
  function MarkersButton(navbar) {
    var _this10;
    _classCallCheck(this, MarkersButton);
    _this10 = _super13.call(this, navbar, {
      className: "psv-markers-button",
      icon: pin_default,
      hoverScale: true,
      collapsable: true,
      tabbable: true
    });
    _this10.plugin = _this10.viewer.getPlugin("markers");
    if (_this10.plugin) {
      _this10.plugin.addEventListener(_ShowMarkersEvent2.type, _assertThisInitialized(_this10));
      _this10.plugin.addEventListener(_HideMarkersEvent2.type, _assertThisInitialized(_this10));
      _this10.toggleActive(true);
    }
    return _this10;
  }
  _createClass(MarkersButton, [{
    key: "destroy",
    value: function destroy() {
      if (this.plugin) {
        this.plugin.removeEventListener(_ShowMarkersEvent2.type, this);
        this.plugin.removeEventListener(_HideMarkersEvent2.type, this);
      }
      _get(_getPrototypeOf(MarkersButton.prototype), "destroy", this).call(this);
    }
  }, {
    key: "isSupported",
    value: function isSupported() {
      return !!this.plugin;
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      if (e instanceof _ShowMarkersEvent2) {
        this.toggleActive(true);
      } else if (e instanceof _HideMarkersEvent2) {
        this.toggleActive(false);
      }
    }
  }, {
    key: "onClick",
    value: function onClick() {
      this.plugin.toggleAllMarkers();
    }
  }]);
  return MarkersButton;
}(AbstractButton);
MarkersButton.id = "markers";

// src/icons/pin-list.svg
var pin_list_default = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="9 9 81 81"><path fill="currentColor" d="M37.5 90S9.9 51.9 9.9 36.6 22.2 9 37.5 9s27.6 12.4 27.6 27.6S37.5 90 37.5 90zm0-66.3c-6.1 0-11 4.9-11 11s4.9 11 11 11 11-4.9 11-11-4.9-11-11-11zM86.7 55H70c-1.8 0-3.3-1.5-3.3-3.3s1.5-3.3 3.3-3.3h16.7c1.8 0 3.3 1.5 3.3 3.3S88.5 55 86.7 55zm0-25h-15a3.3 3.3 0 0 1-3.3-3.3c0-1.8 1.5-3.3 3.3-3.3h15c1.8 0 3.3 1.5 3.3 3.3 0 1.8-1.5 3.3-3.3 3.3zM56.5 73h30c1.8 0 3.3 1.5 3.3 3.3 0 1.8-1.5 3.3-3.3 3.3h-30a3.3 3.3 0 0 1-3.3-3.3 3.2 3.2 0 0 1 3.3-3.3z"/><!--Created by Rohith M S from the Noun Project--></svg>\n';

// src/constants.ts
var SVG_NS = "http://www.w3.org/2000/svg";
var MARKER_DATA = "psvMarker";
var MARKER_DATA_KEY = utils_exports.dasherize(MARKER_DATA);
var ID_PANEL_MARKER = "marker";
var ID_PANEL_MARKERS_LIST = "markersList";
var MARKERS_LIST_TEMPLATE = function MARKERS_LIST_TEMPLATE(markers, title) {
  return "\n<div class=\"psv-panel-menu psv-panel-menu--stripped\">\n <h1 class=\"psv-panel-menu-title\">".concat(pin_list_default, " ").concat(title, "</h1>\n <ul class=\"psv-panel-menu-list\">\n   ").concat(markers.map(function (marker) {
    return "\n   <li data-".concat(MARKER_DATA_KEY, "=\"").concat(marker.id, "\" class=\"psv-panel-menu-item\" tabindex=\"0\">\n     ").concat(marker.type === "image" ? "<span class=\"psv-panel-menu-item-icon\"><img src=\"".concat(marker.definition, "\"/></span>") : "", "\n     <span class=\"psv-panel-menu-item-label\">").concat(marker.getListContent(), "</span>\n   </li>\n   ");
  }).join(""), "\n </ul>\n</div>\n");
};

// src/MarkersListButton.ts
var MarkersListButton = /*#__PURE__*/function (_AbstractButton2) {
  _inherits(MarkersListButton, _AbstractButton2);
  var _super14 = _createSuper(MarkersListButton);
  function MarkersListButton(navbar) {
    var _this11;
    _classCallCheck(this, MarkersListButton);
    _this11 = _super14.call(this, navbar, {
      className: " psv-markers-list-button",
      icon: pin_list_default,
      hoverScale: true,
      collapsable: true,
      tabbable: true
    });
    _this11.plugin = _this11.viewer.getPlugin("markers");
    if (_this11.plugin) {
      _this11.viewer.addEventListener(events_exports$1.ShowPanelEvent.type, _assertThisInitialized(_this11));
      _this11.viewer.addEventListener(events_exports$1.HidePanelEvent.type, _assertThisInitialized(_this11));
    }
    return _this11;
  }
  _createClass(MarkersListButton, [{
    key: "destroy",
    value: function destroy() {
      this.viewer.removeEventListener(events_exports$1.ShowPanelEvent.type, this);
      this.viewer.removeEventListener(events_exports$1.HidePanelEvent.type, this);
      _get(_getPrototypeOf(MarkersListButton.prototype), "destroy", this).call(this);
    }
  }, {
    key: "isSupported",
    value: function isSupported() {
      return !!this.plugin;
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      if (e instanceof events_exports$1.ShowPanelEvent) {
        this.toggleActive(e.panelId === ID_PANEL_MARKERS_LIST);
      } else if (e instanceof events_exports$1.HidePanelEvent) {
        this.toggleActive(false);
      }
    }
  }, {
    key: "onClick",
    value: function onClick() {
      this.plugin.toggleMarkersList();
    }
  }]);
  return MarkersListButton;
}(AbstractButton);
MarkersListButton.id = "markersList";
function greatArcIntermediaryPoint(p1, p2, f) {
  var _p = _slicedToArray(p1, 2),
    λ1 = _p[0],
    φ1 = _p[1];
  var _p2 = _slicedToArray(p2, 2),
    λ2 = _p2[0],
    φ2 = _p2[1];
  var r = utils_exports.greatArcDistance(p1, p2);
  var a = Math.sin((1 - f) * r) / Math.sin(r);
  var b = Math.sin(f * r) / Math.sin(r);
  var x = a * Math.cos(φ1) * Math.cos(λ1) + b * Math.cos(φ2) * Math.cos(λ2);
  var y = a * Math.cos(φ1) * Math.sin(λ1) + b * Math.cos(φ2) * Math.sin(λ2);
  var z = a * Math.sin(φ1) + b * Math.sin(φ2);
  return [Math.atan2(y, x), Math.atan2(z, Math.sqrt(x * x + y * y))];
}
function getPolygonCoherentPoints(points) {
  var workPoints = [points[0]];
  var k = 0;
  for (var i = 1; i < points.length; i++) {
    var d = points[i - 1][0] - points[i][0];
    if (d > Math.PI) {
      k += 1;
    } else if (d < -Math.PI) {
      k -= 1;
    }
    workPoints.push([points[i][0] + k * 2 * Math.PI, points[i][1]]);
  }
  return workPoints;
}
function getPolygonCenter(polygon) {
  var points = getPolygonCoherentPoints(polygon);
  var sum = points.reduce(function (intermediary, point) {
    return [intermediary[0] + point[0], intermediary[1] + point[1]];
  });
  return [utils_exports.parseAngle(sum[0] / polygon.length), sum[1] / polygon.length];
}
function getPolylineCenter(polyline) {
  var points = getPolygonCoherentPoints(polyline);
  var length = 0;
  var lengths = [];
  for (var i = 0; i < points.length - 1; i++) {
    var l = utils_exports.greatArcDistance(points[i], points[i + 1]) * constants_exports.SPHERE_RADIUS;
    lengths.push(l);
    length += l;
  }
  var consumed = 0;
  for (var j = 0; j < points.length - 1; j++) {
    if (consumed + lengths[j] > length / 2) {
      var r = (length / 2 - consumed) / lengths[j];
      return greatArcIntermediaryPoint(points[j], points[j + 1], r);
    }
    consumed += lengths[j];
  }
  return points[Math.round(points.length / 2)];
}

// src/Marker.ts
var MarkerType = /* @__PURE__ */function (MarkerType2) {
  MarkerType2["image"] = "image";
  MarkerType2["imageLayer"] = "imageLayer";
  MarkerType2["html"] = "html";
  MarkerType2["polygon"] = "polygon";
  MarkerType2["polygonPixels"] = "polygonPixels";
  MarkerType2["polyline"] = "polyline";
  MarkerType2["polylinePixels"] = "polylinePixels";
  MarkerType2["square"] = "square";
  MarkerType2["rect"] = "rect";
  MarkerType2["circle"] = "circle";
  MarkerType2["ellipse"] = "ellipse";
  MarkerType2["path"] = "path";
  return MarkerType2;
}(MarkerType || {});
var Marker = /*#__PURE__*/function () {
  function Marker(viewer, config) {
    _classCallCheck(this, Marker);
    this.viewer = viewer;
    this.visible = true;
    this.state = {
      dynamicSize: false,
      anchor: null,
      visible: false,
      staticTooltip: false,
      position: null,
      position2D: null,
      positions3D: null,
      size: null
    };
    if (!config.id) {
      throw new PSVError("missing marker id");
    }
    this.type = Marker.getType(config);
    if (this.isNormal()) {
      this.element = document.createElement("div");
    } else if (this.isPolygon()) {
      this.element = document.createElementNS(SVG_NS, "polygon");
    } else if (this.isPolyline()) {
      this.element = document.createElementNS(SVG_NS, "polyline");
    } else if (this.isSvg()) {
      var svgType = this.type === "square" /* square */ ? "rect" : this.type;
      this.element = document.createElementNS(SVG_NS, svgType);
    } else if (this.is3d()) {
      this.element = this.__createMesh();
      this.loader = new TextureLoader();
      if (this.viewer.config.withCredentials) {
        this.loader.setWithCredentials(true);
      }
    }
    if (!this.is3d()) {
      this.element.id = "psv-marker-".concat(config.id);
      this.element[MARKER_DATA] = this;
    }
    this.update(config);
  }
  _createClass(Marker, [{
    key: "id",
    get: function get() {
      return this.config.id;
    }
  }, {
    key: "data",
    get: function get() {
      return this.config.data;
    }
  }, {
    key: "domElement",
    get: function get() {
      return !this.is3d() ? this.element : null;
    }
  }, {
    key: "threeElement",
    get: function get() {
      return this.is3d() ? this.element : null;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.hideTooltip();
      if (this.is3d()) {
        delete this.threeElement.children[0].userData[MARKER_DATA];
      } else {
        delete this.element[MARKER_DATA];
      }
    }
  }, {
    key: "is3d",
    value: function is3d() {
      return this.type === "imageLayer" /* imageLayer */;
    }
  }, {
    key: "isNormal",
    value: function isNormal() {
      return this.type === "image" /* image */ || this.type === "html" /* html */;
    }
  }, {
    key: "isPoly",
    value: function isPoly() {
      return this.isPolygon() || this.isPolyline();
    }
  }, {
    key: "isPolyPixels",
    value: function isPolyPixels() {
      return this.type === "polygonPixels" /* polygonPixels */ || this.type === "polylinePixels" /* polylinePixels */;
    }
  }, {
    key: "isPolyAngles",
    value: function isPolyAngles() {
      return this.type === "polygon" /* polygon */ || this.type === "polyline" /* polyline */;
    }
  }, {
    key: "isPolygon",
    value: function isPolygon() {
      return this.type === "polygon" /* polygon */ || this.type === "polygonPixels" /* polygonPixels */;
    }
  }, {
    key: "isPolyline",
    value: function isPolyline() {
      return this.type === "polyline" /* polyline */ || this.type === "polylinePixels" /* polylinePixels */;
    }
  }, {
    key: "isSvg",
    value: function isSvg() {
      return this.type === "square" /* square */ || this.type === "rect" /* rect */ || this.type === "circle" /* circle */ || this.type === "ellipse" /* ellipse */ || this.type === "path" /* path */;
    }
  }, {
    key: "getScale",
    value: function getScale(zoomLevel, position) {
      if (!this.config.scale) {
        return 1;
      }
      if (typeof this.config.scale === "function") {
        return this.config.scale(zoomLevel, position);
      }
      var scale = 1;
      if (Array.isArray(this.config.scale.zoom)) {
        var _this$config$scale$zo = _slicedToArray(this.config.scale.zoom, 2),
          min = _this$config$scale$zo[0],
          max = _this$config$scale$zo[1];
        scale *= min + (max - min) * constants_exports.EASINGS.inQuad(zoomLevel / 100);
      }
      if (Array.isArray(this.config.scale.yaw)) {
        var _this$config$scale$ya = _slicedToArray(this.config.scale.yaw, 2),
          _min = _this$config$scale$ya[0],
          _max = _this$config$scale$ya[1];
        var halfFov = MathUtils.degToRad(this.viewer.state.hFov) / 2;
        var arc = Math.abs(utils_exports.getShortestArc(this.state.position.yaw, position.pitch));
        scale *= _max + (_min - _max) * constants_exports.EASINGS.outQuad(Math.max(0, (halfFov - arc) / halfFov));
      }
      return scale;
    }
  }, {
    key: "getListContent",
    value: function getListContent() {
      var _this$config$tooltip;
      if (this.config.listContent) {
        return this.config.listContent;
      } else if ((_this$config$tooltip = this.config.tooltip) !== null && _this$config$tooltip !== void 0 && _this$config$tooltip.content) {
        return this.config.tooltip.content;
      } else if (this.config.html) {
        return this.config.html;
      } else {
        return this.id;
      }
    }
  }, {
    key: "showTooltip",
    value: function showTooltip(clientX, clientY) {
      var _this$config$tooltip2;
      if (this.state.visible && (_this$config$tooltip2 = this.config.tooltip) !== null && _this$config$tooltip2 !== void 0 && _this$config$tooltip2.content && this.state.position2D) {
        var config = _objectSpread(_objectSpread({}, this.config.tooltip), {}, {
          data: this,
          top: 0,
          left: 0
        });
        if (this.isPoly()) {
          if (clientX || clientY) {
            var viewerPos = utils_exports.getPosition(this.viewer.container);
            config.top = clientY - viewerPos.y;
            config.left = clientX - viewerPos.x;
            config.box = {
              width: 20,
              height: 20
            };
          } else {
            config.top = this.state.position2D.y;
            config.left = this.state.position2D.x;
          }
        } else {
          config.top = this.state.position2D.y + this.state.size.height / 2;
          config.left = this.state.position2D.x + this.state.size.width / 2;
          config.box = {
            width: this.state.size.width,
            height: this.state.size.height
          };
        }
        if (this.tooltip) {
          this.tooltip.move(config);
        } else {
          this.tooltip = this.viewer.createTooltip(config);
        }
      }
    }
  }, {
    key: "refreshTooltip",
    value: function refreshTooltip() {
      if (this.tooltip) {
        this.showTooltip();
      }
    }
  }, {
    key: "hideTooltip",
    value: function hideTooltip() {
      if (this.tooltip) {
        this.tooltip.hide();
        this.tooltip = null;
      }
    }
  }, {
    key: "update",
    value: function update(config) {
      var newType = Marker.getType(config, true);
      if (newType !== void 0 && newType !== this.type) {
        throw new PSVError("cannot change marker type");
      }
      if (utils_exports.isExtendedPosition(config)) {
        utils_exports.logWarn('Use the "position" property to configure the position of a marker');
        config.position = this.viewer.dataHelper.cleanPosition(config);
      }
      if ("width" in config && "height" in config) {
        utils_exports.logWarn('Use the "size" property to configure the size of a marker');
        config.size = {
          width: config["width"],
          height: config["height"]
        };
      }
      this.config = utils_exports.deepmerge(this.config, config);
      if (typeof this.config.tooltip === "string") {
        this.config.tooltip = {
          content: this.config.tooltip
        };
      }
      if (this.config.tooltip && !this.config.tooltip.trigger) {
        this.config.tooltip.trigger = "hover";
      }
      if (this.config.scale && Array.isArray(this.config.scale)) {
        this.config.scale = {
          zoom: this.config.scale
        };
      }
      this.visible = this.config.visible !== false;
      this.state.anchor = utils_exports.parsePoint(this.config.anchor);
      if (!this.is3d()) {
        var _this$config$opacity;
        var element = this.domElement;
        if (this.isNormal()) {
          element.setAttribute("class", "psv-marker psv-marker--normal");
        } else {
          element.setAttribute("class", "psv-marker psv-marker--svg");
        }
        if (this.config.className) {
          utils_exports.addClasses(element, this.config.className);
        }
        if (this.config.tooltip) {
          element.classList.add("psv-marker--has-tooltip");
        }
        if (this.config.content) {
          element.classList.add("psv-marler--has-content");
        }
        element.style.opacity = "".concat((_this$config$opacity = this.config.opacity) !== null && _this$config$opacity !== void 0 ? _this$config$opacity : 1);
        if (this.config.style) {
          Object.assign(element.style, this.config.style);
        }
      }
      if (this.isNormal()) {
        this.__updateNormal();
      } else if (this.isPoly()) {
        this.__updatePoly();
      } else if (this.isSvg()) {
        this.__updateSvg();
      } else if (this.is3d()) {
        this.__update3d();
      }
    }
  }, {
    key: "__updateNormal",
    value: function __updateNormal() {
      var element = this.domElement;
      if (!utils_exports.isExtendedPosition(this.config.position)) {
        throw new PSVError("missing marker position");
      }
      if (this.config.image && !this.config.size) {
        throw new PSVError("missing marker size");
      }
      if (this.config.size) {
        this.state.dynamicSize = false;
        this.state.size = this.config.size;
        element.style.width = this.config.size.width + "px";
        element.style.height = this.config.size.height + "px";
      } else {
        this.state.dynamicSize = true;
      }
      if (this.config.image) {
        this.definition = this.config.image;
        element.style.backgroundImage = "url(".concat(this.config.image, ")");
      } else if (this.config.html) {
        this.definition = this.config.html;
        element.innerHTML = this.config.html;
      }
      element.style.transformOrigin = "".concat(this.state.anchor.x * 100, "% ").concat(this.state.anchor.y * 100, "%");
      this.state.position = this.viewer.dataHelper.cleanPosition(this.config.position);
      this.state.positions3D = [this.viewer.dataHelper.sphericalCoordsToVector3(this.state.position)];
    }
  }, {
    key: "__updateSvg",
    value: function __updateSvg() {
      var element = this.domElement;
      if (!utils_exports.isExtendedPosition(this.config.position)) {
        throw new PSVError("missing marker position");
      }
      this.state.dynamicSize = true;
      switch (this.type) {
        case "square" /* square */:
          this.definition = {
            x: 0,
            y: 0,
            width: this.config.square,
            height: this.config.square
          };
          break;
        case "rect" /* rect */:
          if (Array.isArray(this.config.rect)) {
            this.definition = {
              x: 0,
              y: 0,
              width: this.config.rect[0],
              height: this.config.rect[1]
            };
          } else {
            this.definition = {
              x: 0,
              y: 0,
              width: this.config.rect.width,
              height: this.config.rect.height
            };
          }
          break;
        case "circle" /* circle */:
          this.definition = {
            cx: this.config.circle,
            cy: this.config.circle,
            r: this.config.circle
          };
          break;
        case "ellipse" /* ellipse */:
          if (Array.isArray(this.config.ellipse)) {
            this.definition = {
              cx: this.config.ellipse[0],
              cy: this.config.ellipse[1],
              rx: this.config.ellipse[0],
              ry: this.config.ellipse[1]
            };
          } else {
            this.definition = {
              cx: this.config.ellipse.rx,
              cy: this.config.ellipse.ry,
              rx: this.config.ellipse.rx,
              ry: this.config.ellipse.ry
            };
          }
          break;
        case "path" /* path */:
          this.definition = {
            d: this.config.path
          };
          break;
      }
      Object.entries(this.definition).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          prop = _ref2[0],
          value = _ref2[1];
        element.setAttributeNS(null, prop, value);
      });
      if (this.config.svgStyle) {
        Object.entries(this.config.svgStyle).forEach(function (_ref3) {
          var _ref4 = _slicedToArray(_ref3, 2),
            prop = _ref4[0],
            value = _ref4[1];
          element.setAttributeNS(null, utils_exports.dasherize(prop), value);
        });
      } else {
        element.setAttributeNS(null, "fill", "rgba(0,0,0,0.5)");
      }
      this.state.position = this.viewer.dataHelper.cleanPosition(this.config.position);
      this.state.positions3D = [this.viewer.dataHelper.sphericalCoordsToVector3(this.state.position)];
    }
  }, {
    key: "__updatePoly",
    value: function __updatePoly() {
      var _this12 = this;
      var element = this.domElement;
      this.state.dynamicSize = true;
      if (this.config.svgStyle) {
        Object.entries(this.config.svgStyle).forEach(function (_ref5) {
          var _ref6 = _slicedToArray(_ref5, 2),
            prop = _ref6[0],
            value = _ref6[1];
          element.setAttributeNS(null, utils_exports.dasherize(prop), value);
        });
        if (this.isPolyline() && !this.config.svgStyle.fill) {
          element.setAttributeNS(null, "fill", "none");
        }
      } else if (this.isPolygon()) {
        element.setAttributeNS(null, "fill", "rgba(0,0,0,0.5)");
      } else if (this.isPolyline()) {
        element.setAttributeNS(null, "fill", "none");
        element.setAttributeNS(null, "stroke", "rgb(0,0,0)");
      }
      var actualPoly = this.config[this.type];
      if (!Array.isArray(actualPoly[0])) {
        for (var i = 0; i < actualPoly.length; i++) {
          actualPoly.splice(i, 2, [actualPoly[i], actualPoly[i + 1]]);
        }
      }
      if (this.isPolyPixels()) {
        this.definition = actualPoly.map(function (coord) {
          var sphericalCoords = _this12.viewer.dataHelper.textureCoordsToSphericalCoords({
            textureX: coord[0],
            textureY: coord[1]
          });
          return [sphericalCoords.yaw, sphericalCoords.pitch];
        });
      } else {
        this.definition = actualPoly.map(function (coord) {
          return [utils_exports.parseAngle(coord[0]), utils_exports.parseAngle(coord[1], true)];
        });
      }
      var centroid = this.isPolygon() ? getPolygonCenter(this.definition) : getPolylineCenter(this.definition);
      this.state.position = {
        yaw: centroid[0],
        pitch: centroid[1]
      };
      this.state.positions3D = this.definition.map(function (coord) {
        return _this12.viewer.dataHelper.sphericalCoordsToVector3({
          yaw: coord[0],
          pitch: coord[1]
        });
      });
    }
  }, {
    key: "__update3d",
    value: function __update3d() {
      var _this13 = this,
        _this$config$opacity2;
      var element = this.threeElement;
      if (!utils_exports.isExtendedPosition(this.config.position)) {
        throw new PSVError("missing marker position");
      }
      if (!this.config.size) {
        throw new PSVError("missing marker size");
      }
      this.state.dynamicSize = false;
      this.state.size = this.config.size;
      this.state.position = this.viewer.dataHelper.cleanPosition(this.config.position);
      this.state.positions3D = [this.viewer.dataHelper.sphericalCoordsToVector3(this.state.position)];
      switch (this.type) {
        case "imageLayer" /* imageLayer */:
          if (this.definition !== this.config.imageLayer) {
            if (this.viewer.config.requestHeaders) {
              this.loader.setRequestHeader(this.viewer.config.requestHeaders(this.config.imageLayer));
            }
            element.children[0].material.map = this.loader.load(this.config.imageLayer, function (texture) {
              texture.anisotropy = 4;
              _this13.viewer.needsUpdate();
            });
            this.definition = this.config.imageLayer;
          }
          element.children[0].position.set(this.state.anchor.x - 0.5, this.state.anchor.y - 0.5, 0);
          element.children[0].material.opacity = (_this$config$opacity2 = this.config.opacity) !== null && _this$config$opacity2 !== void 0 ? _this$config$opacity2 : 1;
          element.position.copy(this.state.positions3D[0]);
          switch (this.config.orientation) {
            case "horizontal":
              element.lookAt(0, element.position.y, 0);
              element.rotateX(this.state.position.pitch < 0 ? -Math.PI / 2 : Math.PI / 2);
              break;
            case "vertical-left":
              element.lookAt(0, 0, 0);
              element.rotateY(-Math.PI * 0.4);
              break;
            case "vertical-right":
              element.lookAt(0, 0, 0);
              element.rotateY(Math.PI * 0.4);
              break;
            default:
              element.lookAt(0, 0, 0);
              break;
          }
          element.scale.set(this.config.size.width / 100, this.config.size.height / 100, 1);
          break;
      }
    }
  }, {
    key: "__createMesh",
    value: function __createMesh() {
      var material = new MeshBasicMaterial({
        transparent: true,
        opacity: 1,
        depthTest: false
      });
      var geometry = new PlaneGeometry(1, 1);
      var mesh = new Mesh(geometry, material);
      mesh.userData = _defineProperty({}, MARKER_DATA, this);
      var element = new Group().add(mesh);
      Object.defineProperty(element, "visible", {
        enumerable: true,
        get: function get() {
          return this.children[0].userData[MARKER_DATA].visible;
        },
        set: function set(visible) {
          this.children[0].userData[MARKER_DATA].visible = visible;
        }
      });
      return element;
    }
  }], [{
    key: "getType",
    value: function getType(config) {
      var allowNone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var found = [];
      Object.keys(MarkerType).forEach(function (type) {
        if (config[type]) {
          found.push(type);
        }
      });
      if (found.length === 0 && !allowNone) {
        throw new PSVError("missing marker content, either ".concat(Object.keys(MarkerType).join(", ")));
      } else if (found.length > 1) {
        throw new PSVError("multiple marker content, either ".concat(Object.keys(MarkerType).join(", ")));
      }
      return found[0];
    }
  }]);
  return Marker;
}();

// src/MarkersPlugin.ts
var getConfig = utils_exports.getConfigParser({
  clickEventOnMarker: false,
  gotoMarkerSpeed: "8rpm",
  markers: null
});
var MarkersPlugin = /*#__PURE__*/function (_AbstractConfigurable) {
  _inherits(MarkersPlugin, _AbstractConfigurable);
  var _super15 = _createSuper(MarkersPlugin);
  function MarkersPlugin(viewer, config) {
    var _this14;
    _classCallCheck(this, MarkersPlugin);
    _this14 = _super15.call(this, viewer, config);
    _this14.markers = {};
    _this14.state = {
      visible: true,
      showAllTooltips: false,
      currentMarker: null,
      hoveringMarker: null
    };
    _this14.container = document.createElement("div");
    _this14.container.className = "psv-markers";
    _this14.container.style.cursor = _this14.viewer.config.mousemove ? "move" : "default";
    _this14.svgContainer = document.createElementNS(SVG_NS, "svg");
    _this14.svgContainer.setAttribute("class", "psv-markers-svg-container");
    _this14.container.appendChild(_this14.svgContainer);
    _this14.container.addEventListener("mouseenter", _assertThisInitialized(_this14), true);
    _this14.container.addEventListener("mouseleave", _assertThisInitialized(_this14), true);
    _this14.container.addEventListener("mousemove", _assertThisInitialized(_this14), true);
    _this14.container.addEventListener("contextmenu", _assertThisInitialized(_this14));
    return _this14;
  }
  _createClass(MarkersPlugin, [{
    key: "init",
    value: function init() {
      _get(_getPrototypeOf(MarkersPlugin.prototype), "init", this).call(this);
      this.viewer.container.appendChild(this.container);
      this.viewer.addEventListener(events_exports$1.ClickEvent.type, this);
      this.viewer.addEventListener(events_exports$1.DoubleClickEvent.type, this);
      this.viewer.addEventListener(events_exports$1.RenderEvent.type, this);
      this.viewer.addEventListener(events_exports$1.ConfigChangedEvent.type, this);
      this.viewer.addEventListener(events_exports$1.ObjectEnterEvent.type, this);
      this.viewer.addEventListener(events_exports$1.ObjectHoverEvent.type, this);
      this.viewer.addEventListener(events_exports$1.ObjectLeaveEvent.type, this);
      this.viewer.addEventListener(events_exports$1.ReadyEvent.type, this, {
        once: true
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.clearMarkers(false);
      this.viewer.unobserveObjects(MARKER_DATA);
      this.viewer.removeEventListener(events_exports$1.ClickEvent.type, this);
      this.viewer.removeEventListener(events_exports$1.DoubleClickEvent.type, this);
      this.viewer.removeEventListener(events_exports$1.RenderEvent.type, this);
      this.viewer.removeEventListener(events_exports$1.ConfigChangedEvent.type, this);
      this.viewer.removeEventListener(events_exports$1.ObjectEnterEvent.type, this);
      this.viewer.removeEventListener(events_exports$1.ObjectHoverEvent.type, this);
      this.viewer.removeEventListener(events_exports$1.ObjectLeaveEvent.type, this);
      this.viewer.removeEventListener(events_exports$1.ReadyEvent.type, this);
      this.viewer.container.removeChild(this.container);
      _get(_getPrototypeOf(MarkersPlugin.prototype), "destroy", this).call(this);
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      switch (e.type) {
        case events_exports$1.ReadyEvent.type:
          if (this.config.markers) {
            this.setMarkers(this.config.markers);
            delete this.config.markers;
          }
          break;
        case events_exports$1.RenderEvent.type:
          this.renderMarkers();
          break;
        case events_exports$1.ClickEvent.type:
          this.__onClick(e, false);
          break;
        case events_exports$1.DoubleClickEvent.type:
          this.__onClick(e, true);
          break;
        case events_exports$1.ConfigChangedEvent.type:
          this.container.style.cursor = this.viewer.config.mousemove ? "move" : "default";
          break;
        case events_exports$1.ObjectEnterEvent.type:
        case events_exports$1.ObjectLeaveEvent.type:
        case events_exports$1.ObjectHoverEvent.type:
          if (e.userDataKey === MARKER_DATA) {
            var event = e.originalEvent;
            var marker = e.object.userData[MARKER_DATA];
            switch (e.type) {
              case events_exports$1.ObjectEnterEvent.type:
                this.__onMouseEnter(event, marker);
                break;
              case events_exports$1.ObjectLeaveEvent.type:
                this.__onMouseLeave(event, marker);
                break;
              case events_exports$1.ObjectHoverEvent.type:
                this.__onMouseMove(event, marker);
                break;
            }
          }
          break;
        case "mouseenter":
          this.__onMouseEnter(e, this.__getTargetMarker(e.target));
          break;
        case "mouseleave":
          this.__onMouseLeave(e, this.__getTargetMarker(e.target));
          break;
        case "mousemove":
          this.__onMouseMove(e, this.__getTargetMarker(e.target));
          break;
        case "contextmenu":
          e.preventDefault();
          break;
      }
    }
  }, {
    key: "toggleAllMarkers",
    value: function toggleAllMarkers() {
      if (this.state.visible) {
        this.hideAllMarkers();
      } else {
        this.showAllMarkers();
      }
    }
  }, {
    key: "showAllMarkers",
    value: function showAllMarkers() {
      this.state.visible = true;
      this.renderMarkers();
      this.dispatchEvent(new _ShowMarkersEvent2());
    }
  }, {
    key: "hideAllMarkers",
    value: function hideAllMarkers() {
      this.state.visible = false;
      this.renderMarkers();
      this.dispatchEvent(new _HideMarkersEvent2());
    }
  }, {
    key: "toggleAllTooltips",
    value: function toggleAllTooltips() {
      if (this.state.showAllTooltips) {
        this.hideAllTooltips();
      } else {
        this.showAllTooltips();
      }
    }
  }, {
    key: "showAllTooltips",
    value: function showAllTooltips() {
      this.state.showAllTooltips = true;
      Object.values(this.markers).forEach(function (marker) {
        marker.state.staticTooltip = true;
        marker.showTooltip();
      });
    }
  }, {
    key: "hideAllTooltips",
    value: function hideAllTooltips() {
      this.state.showAllTooltips = false;
      Object.values(this.markers).forEach(function (marker) {
        marker.state.staticTooltip = false;
        marker.hideTooltip();
      });
    }
  }, {
    key: "getNbMarkers",
    value: function getNbMarkers() {
      return Object.keys(this.markers).length;
    }
  }, {
    key: "getMarkers",
    value: function getMarkers() {
      return Object.values(this.markers);
    }
  }, {
    key: "addMarker",
    value: function addMarker(config) {
      var render = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      if (this.markers[config.id]) {
        throw new PSVError("marker \"".concat(config.id, "\" already exists"));
      }
      var marker = new Marker(this.viewer, config);
      if (marker.isNormal()) {
        this.container.appendChild(marker.domElement);
      } else if (marker.isPoly() || marker.isSvg()) {
        this.svgContainer.appendChild(marker.domElement);
      } else if (marker.is3d()) {
        this.viewer.renderer.addObject(marker.threeElement);
      } else {
        throw new PSVError("invalid state");
      }
      this.markers[marker.id] = marker;
      if (render) {
        this.__afterChangerMarkers();
      }
    }
  }, {
    key: "getMarker",
    value: function getMarker(markerId) {
      var id = _typeof(markerId) === "object" ? markerId.id : markerId;
      if (!this.markers[id]) {
        throw new PSVError("cannot find marker \"".concat(id, "\""));
      }
      return this.markers[id];
    }
  }, {
    key: "getCurrentMarker",
    value: function getCurrentMarker() {
      return this.state.currentMarker;
    }
  }, {
    key: "updateMarker",
    value: function updateMarker(config) {
      var render = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var marker = this.getMarker(config.id);
      marker.update(config);
      if (render) {
        this.__afterChangerMarkers();
      }
    }
  }, {
    key: "removeMarker",
    value: function removeMarker(markerId) {
      var render = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var marker = this.getMarker(markerId);
      if (marker.isNormal()) {
        this.container.removeChild(marker.domElement);
      } else if (marker.isPoly() || marker.isSvg()) {
        this.svgContainer.removeChild(marker.domElement);
      } else if (marker.is3d()) {
        this.viewer.renderer.removeObject(marker.threeElement);
      }
      if (this.state.hoveringMarker === marker) {
        this.state.hoveringMarker = null;
      }
      if (this.state.currentMarker === marker) {
        this.state.currentMarker = null;
      }
      marker.destroy();
      delete this.markers[marker.id];
      if (render) {
        this.__afterChangerMarkers();
      }
    }
  }, {
    key: "removeMarkers",
    value: function removeMarkers(markerIds) {
      var _this15 = this;
      var render = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      markerIds.forEach(function (markerId) {
        return _this15.removeMarker(markerId, false);
      });
      if (render) {
        this.__afterChangerMarkers();
      }
    }
  }, {
    key: "setMarkers",
    value: function setMarkers(markers) {
      var _this16 = this;
      var render = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.clearMarkers(false);
      markers === null || markers === void 0 ? void 0 : markers.forEach(function (marker) {
        _this16.addMarker(marker, false);
      });
      if (render) {
        this.__afterChangerMarkers();
      }
    }
  }, {
    key: "clearMarkers",
    value: function clearMarkers() {
      var _this17 = this;
      var render = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      Object.keys(this.markers).forEach(function (markerId) {
        _this17.removeMarker(markerId, false);
      });
      if (render) {
        this.__afterChangerMarkers();
      }
    }
  }, {
    key: "gotoMarker",
    value: function gotoMarker(markerId) {
      var _this18 = this;
      var speed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.config.gotoMarkerSpeed;
      var marker = this.getMarker(markerId);
      if (!speed) {
        this.viewer.rotate(marker.state.position);
        if (!utils_exports.isNil(marker.config.zoomLvl)) {
          this.viewer.zoom(marker.config.zoomLvl);
        }
        this.dispatchEvent(new _GotoMarkerDoneEvent2(marker));
        return Promise.resolve();
      } else {
        return this.viewer.animate(_objectSpread(_objectSpread({}, marker.state.position), {}, {
          zoom: marker.config.zoomLvl,
          speed: speed
        })).then(function () {
          _this18.dispatchEvent(new _GotoMarkerDoneEvent2(marker));
        });
      }
    }
  }, {
    key: "hideMarker",
    value: function hideMarker(markerId) {
      this.toggleMarker(markerId, false);
    }
  }, {
    key: "showMarker",
    value: function showMarker(markerId) {
      this.toggleMarker(markerId, true);
    }
  }, {
    key: "showMarkerTooltip",
    value: function showMarkerTooltip(markerId) {
      var marker = this.getMarker(markerId);
      marker.state.staticTooltip = true;
      marker.showTooltip();
    }
  }, {
    key: "hideMarkerTooltip",
    value: function hideMarkerTooltip(markerId) {
      var marker = this.getMarker(markerId);
      marker.state.staticTooltip = false;
      marker.hideTooltip();
    }
  }, {
    key: "toggleMarker",
    value: function toggleMarker(markerId, visible) {
      var marker = this.getMarker(markerId);
      marker.visible = visible === null ? !marker.visible : visible;
      this.viewer.needsUpdate();
    }
  }, {
    key: "showMarkerPanel",
    value: function showMarkerPanel(markerId) {
      var _marker$config;
      var marker = this.getMarker(markerId);
      if (marker !== null && marker !== void 0 && (_marker$config = marker.config) !== null && _marker$config !== void 0 && _marker$config.content) {
        this.viewer.panel.show({
          id: ID_PANEL_MARKER,
          content: marker.config.content
        });
      } else {
        this.hideMarkerPanel();
      }
    }
  }, {
    key: "hideMarkerPanel",
    value: function hideMarkerPanel() {
      this.viewer.panel.hide(ID_PANEL_MARKER);
    }
  }, {
    key: "toggleMarkersList",
    value: function toggleMarkersList() {
      if (this.viewer.panel.isVisible(ID_PANEL_MARKERS_LIST)) {
        this.hideMarkersList();
      } else {
        this.showMarkersList();
      }
    }
  }, {
    key: "showMarkersList",
    value: function showMarkersList() {
      var _this19 = this;
      var markers = [];
      Object.values(this.markers).forEach(function (marker) {
        if (marker.visible && !marker.config.hideList) {
          markers.push(marker);
        }
      });
      var e = new _RenderMarkersListEvent2(markers);
      this.dispatchEvent(e);
      markers = e.markers;
      this.viewer.panel.show({
        id: ID_PANEL_MARKERS_LIST,
        content: MARKERS_LIST_TEMPLATE(markers, this.viewer.config.lang[MarkersButton.id]),
        noMargin: true,
        clickHandler: function clickHandler(target) {
          var li = utils_exports.getClosest(target, "li");
          var markerId = li ? li.dataset[MARKER_DATA] : void 0;
          if (markerId) {
            var marker = _this19.getMarker(markerId);
            _this19.dispatchEvent(new _SelectMarkerListEvent2(marker));
            _this19.gotoMarker(marker.id);
            _this19.hideMarkersList();
          }
        }
      });
    }
  }, {
    key: "hideMarkersList",
    value: function hideMarkersList() {
      this.viewer.panel.hide(ID_PANEL_MARKERS_LIST);
    }
  }, {
    key: "renderMarkers",
    value: function renderMarkers() {
      var _this20 = this;
      var zoomLevel = this.viewer.getZoomLevel();
      var viewerPosition = this.viewer.getPosition();
      Object.values(this.markers).forEach(function (marker) {
        var _marker$config$toolti;
        var isVisible = _this20.state.visible && marker.visible;
        var visibilityChanged = false;
        var position = null;
        if (isVisible && marker.is3d()) {
          position = _this20.__getMarkerPosition(marker);
          isVisible = _this20.__isMarkerVisible(marker, position);
        } else if (isVisible && marker.isPoly()) {
          var positions = _this20.__getPolyPositions(marker);
          isVisible = positions.length > (marker.isPolygon() ? 2 : 1);
          if (isVisible) {
            position = _this20.__getMarkerPosition(marker);
            var points = positions.map(function (pos) {
              return pos.x - position.x + "," + (pos.y - position.y);
            }).join(" ");
            marker.domElement.setAttributeNS(null, "points", points);
            marker.domElement.setAttributeNS(null, "transform", "translate(".concat(position.x, " ").concat(position.y, ")"));
          }
        } else if (isVisible) {
          if (marker.state.dynamicSize) {
            _this20.__updateMarkerSize(marker);
          }
          position = _this20.__getMarkerPosition(marker);
          isVisible = _this20.__isMarkerVisible(marker, position);
          if (isVisible) {
            var scale = marker.getScale(zoomLevel, viewerPosition);
            if (marker.isSvg()) {
              var x = position.x + marker.state.size.width * marker.state.anchor.x * (1 - scale);
              var y = position.y + marker.state.size.height * marker.state.anchor.y * (1 - scale);
              marker.domElement.setAttributeNS(null, "transform", "translate(".concat(x, ", ").concat(y, ") scale(").concat(scale, ", ").concat(scale, ")"));
            } else {
              marker.domElement.style.transform = "translate3D(".concat(position.x, "px, ").concat(position.y, "px, 0px) scale(").concat(scale, ", ").concat(scale, ")");
            }
          }
        }
        visibilityChanged = marker.state.visible !== isVisible;
        marker.state.visible = isVisible;
        marker.state.position2D = isVisible ? position : null;
        if (!marker.is3d()) {
          utils_exports.toggleClass(marker.domElement, "psv-marker--visible", isVisible);
        }
        if (!isVisible) {
          marker.hideTooltip();
        } else if (marker.state.staticTooltip) {
          marker.showTooltip();
        } else if (((_marker$config$toolti = marker.config.tooltip) === null || _marker$config$toolti === void 0 ? void 0 : _marker$config$toolti.trigger) === "click" || marker === _this20.state.hoveringMarker && !marker.isPoly()) {
          marker.refreshTooltip();
        } else if (marker !== _this20.state.hoveringMarker) {
          marker.hideTooltip();
        }
        if (visibilityChanged) {
          _this20.dispatchEvent(new _MarkerVisibilityEvent2(marker, isVisible));
        }
      });
    }
  }, {
    key: "__isMarkerVisible",
    value: function __isMarkerVisible(marker, position) {
      return marker.state.positions3D[0].dot(this.viewer.state.direction) > 0 && position.x + marker.state.size.width >= 0 && position.x - marker.state.size.width <= this.viewer.state.size.width && position.y + marker.state.size.height >= 0 && position.y - marker.state.size.height <= this.viewer.state.size.height;
    }
  }, {
    key: "__updateMarkerSize",
    value: function __updateMarkerSize(marker) {
      var element = marker.domElement;
      element.classList.add("psv-marker--transparent");
      var transform;
      if (marker.isSvg()) {
        transform = element.getAttributeNS(null, "transform");
        element.removeAttributeNS(null, "transform");
      } else {
        transform = element.style.transform;
        element.style.transform = "";
      }
      var rect = element.getBoundingClientRect();
      marker.state.size = {
        width: rect.width,
        height: rect.height
      };
      element.classList.remove("psv-marker--transparent");
      if (transform) {
        if (marker.isSvg()) {
          element.setAttributeNS(null, "transform", transform);
        } else {
          element.style.transform = transform;
        }
      }
      marker.state.dynamicSize = false;
    }
  }, {
    key: "__getMarkerPosition",
    value: function __getMarkerPosition(marker) {
      if (marker.isPoly()) {
        return this.viewer.dataHelper.sphericalCoordsToViewerCoords(marker.state.position);
      } else {
        var position = this.viewer.dataHelper.vector3ToViewerCoords(marker.state.positions3D[0]);
        position.x -= marker.state.size.width * marker.state.anchor.x;
        position.y -= marker.state.size.height * marker.state.anchor.y;
        return position;
      }
    }
  }, {
    key: "__getPolyPositions",
    value: function __getPolyPositions(marker) {
      var _this21 = this;
      var nbVectors = marker.state.positions3D.length;
      var positions3D = marker.state.positions3D.map(function (vector) {
        return {
          vector: vector,
          visible: vector.dot(_this21.viewer.state.direction) > 0
        };
      });
      var toBeComputed = [];
      positions3D.forEach(function (pos, i) {
        if (!pos.visible) {
          var neighbours = [i === 0 ? positions3D[nbVectors - 1] : positions3D[i - 1], i === nbVectors - 1 ? positions3D[0] : positions3D[i + 1]];
          neighbours.forEach(function (neighbour) {
            if (neighbour.visible) {
              toBeComputed.push({
                visible: neighbour.vector,
                invisible: pos.vector,
                index: i
              });
            }
          });
        }
      });
      toBeComputed.reverse().forEach(function (pair) {
        positions3D.splice(pair.index, 0, {
          vector: _this21.__getPolyIntermediaryPoint(pair.visible, pair.invisible),
          visible: true
        });
      });
      return positions3D.filter(function (pos) {
        return pos.visible;
      }).map(function (pos) {
        return _this21.viewer.dataHelper.vector3ToViewerCoords(pos.vector);
      });
    }
  }, {
    key: "__getPolyIntermediaryPoint",
    value: function __getPolyIntermediaryPoint(P1, P2) {
      var C = this.viewer.state.direction.clone().normalize();
      var N = new Vector3().crossVectors(P1, P2).normalize();
      var V = new Vector3().crossVectors(N, P1).normalize();
      var X = P1.clone().multiplyScalar(-C.dot(V));
      var Y = V.clone().multiplyScalar(C.dot(P1));
      var H = new Vector3().addVectors(X, Y).normalize();
      var a = new Vector3().crossVectors(H, C);
      return H.applyAxisAngle(a, 0.01).multiplyScalar(constants_exports.SPHERE_RADIUS);
    }
  }, {
    key: "__getTargetMarker",
    value: function __getTargetMarker(target) {
      var closest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var target2 = closest ? utils_exports.getClosest(target, ".psv-marker") : target;
      return target2 ? target2[MARKER_DATA] : void 0;
    }
  }, {
    key: "__targetOnTooltip",
    value: function __targetOnTooltip(target, tooltip) {
      return target && tooltip ? utils_exports.hasParent(target, tooltip.container) : false;
    }
  }, {
    key: "__onMouseEnter",
    value: function __onMouseEnter(e, marker) {
      if (marker && !marker.isPoly()) {
        var _marker$config$toolti2;
        this.state.hoveringMarker = marker;
        this.dispatchEvent(new _EnterMarkerEvent2(marker));
        if (!marker.state.staticTooltip && ((_marker$config$toolti2 = marker.config.tooltip) === null || _marker$config$toolti2 === void 0 ? void 0 : _marker$config$toolti2.trigger) === "hover") {
          marker.showTooltip(e.clientX, e.clientY);
        }
      }
    }
  }, {
    key: "__onMouseLeave",
    value: function __onMouseLeave(e, marker) {
      if (marker && !(marker.isPoly() && this.__targetOnTooltip(e.relatedTarget, marker.tooltip))) {
        var _marker$config$toolti3;
        this.dispatchEvent(new _LeaveMarkerEvent2(marker));
        this.state.hoveringMarker = null;
        if (!marker.state.staticTooltip && ((_marker$config$toolti3 = marker.config.tooltip) === null || _marker$config$toolti3 === void 0 ? void 0 : _marker$config$toolti3.trigger) === "hover") {
          marker.hideTooltip();
        }
      }
    }
  }, {
    key: "__onMouseMove",
    value: function __onMouseMove(e, targetMarker) {
      var _this$state$hoveringM;
      var marker;
      if (targetMarker !== null && targetMarker !== void 0 && targetMarker.isPoly()) {
        marker = targetMarker;
      } else if (this.state.hoveringMarker && this.__targetOnTooltip(e.target, this.state.hoveringMarker.tooltip)) {
        marker = this.state.hoveringMarker;
      }
      if (marker) {
        if (!this.state.hoveringMarker) {
          this.dispatchEvent(new _EnterMarkerEvent2(marker));
          this.state.hoveringMarker = marker;
        }
        if (!marker.state.staticTooltip) {
          marker.showTooltip(e.clientX, e.clientY);
        }
      } else if ((_this$state$hoveringM = this.state.hoveringMarker) !== null && _this$state$hoveringM !== void 0 && _this$state$hoveringM.isPoly()) {
        this.dispatchEvent(new _LeaveMarkerEvent2(this.state.hoveringMarker));
        if (!this.state.hoveringMarker.state.staticTooltip) {
          this.state.hoveringMarker.hideTooltip();
        }
        this.state.hoveringMarker = null;
      }
    }
  }, {
    key: "__onClick",
    value: function __onClick(e, dblclick) {
      var _e$data$objects$find;
      var marker = (_e$data$objects$find = e.data.objects.find(function (o) {
        return o.userData[MARKER_DATA];
      })) === null || _e$data$objects$find === void 0 ? void 0 : _e$data$objects$find.userData[MARKER_DATA];
      if (!marker) {
        marker = this.__getTargetMarker(e.data.target, true);
      }
      if (this.state.currentMarker && this.state.currentMarker !== marker) {
        var _this$state$currentMa;
        this.dispatchEvent(new _UnselectMarkerEvent2(this.state.currentMarker));
        this.viewer.panel.hide(ID_PANEL_MARKER);
        if (!this.state.showAllTooltips && ((_this$state$currentMa = this.state.currentMarker.config.tooltip) === null || _this$state$currentMa === void 0 ? void 0 : _this$state$currentMa.trigger) === "click") {
          this.hideMarkerTooltip(this.state.currentMarker.id);
        }
        this.state.currentMarker = null;
      }
      if (marker) {
        this.state.currentMarker = marker;
        this.dispatchEvent(new _SelectMarkerEvent2(marker, dblclick, e.data.rightclick));
        if (this.config.clickEventOnMarker) {
          e.data.marker = marker;
        } else {
          e.stopImmediatePropagation();
        }
        if (this.markers[marker.id]) {
          var _marker$config$toolti4;
          if (((_marker$config$toolti4 = marker.config.tooltip) === null || _marker$config$toolti4 === void 0 ? void 0 : _marker$config$toolti4.trigger) === "click") {
            if (marker.tooltip) {
              this.hideMarkerTooltip(marker);
            } else {
              this.showMarkerTooltip(marker);
            }
          } else {
            this.showMarkerPanel(marker.id);
          }
        }
      }
    }
  }, {
    key: "__afterChangerMarkers",
    value: function __afterChangerMarkers() {
      this.__refreshUi();
      this.__checkObjectsObserver();
      this.viewer.needsUpdate();
      this.dispatchEvent(new _SetMarkersEvent2(this.getMarkers()));
    }
  }, {
    key: "__refreshUi",
    value: function __refreshUi() {
      var _this$viewer$navbar$g, _this$viewer$navbar$g2;
      var nbMarkers = Object.values(this.markers).filter(function (m) {
        return !m.config.hideList;
      }).length;
      if (nbMarkers === 0) {
        if (this.viewer.panel.isVisible(ID_PANEL_MARKERS_LIST) || this.viewer.panel.isVisible(ID_PANEL_MARKER)) {
          this.viewer.panel.hide();
        }
      } else {
        if (this.viewer.panel.isVisible(ID_PANEL_MARKERS_LIST)) {
          this.showMarkersList();
        } else if (this.viewer.panel.isVisible(ID_PANEL_MARKER)) {
          this.state.currentMarker ? this.showMarkerPanel(this.state.currentMarker.id) : this.viewer.panel.hide();
        }
      }
      (_this$viewer$navbar$g = this.viewer.navbar.getButton(MarkersButton.id, false)) === null || _this$viewer$navbar$g === void 0 ? void 0 : _this$viewer$navbar$g.toggle(nbMarkers > 0);
      (_this$viewer$navbar$g2 = this.viewer.navbar.getButton(MarkersListButton.id, false)) === null || _this$viewer$navbar$g2 === void 0 ? void 0 : _this$viewer$navbar$g2.toggle(nbMarkers > 0);
    }
  }, {
    key: "__checkObjectsObserver",
    value: function __checkObjectsObserver() {
      var has3d = Object.values(this.markers).some(function (marker) {
        return marker.is3d();
      });
      if (has3d) {
        this.viewer.observeObjects(MARKER_DATA);
      } else {
        this.viewer.unobserveObjects(MARKER_DATA);
      }
    }
  }]);
  return MarkersPlugin;
}(AbstractConfigurablePlugin);
MarkersPlugin.id = "markers";
MarkersPlugin.configParser = getConfig;
MarkersPlugin.readonlyOptions = ["markers"];

// src/index.ts
DEFAULTS.lang[MarkersButton.id] = "Markers";
DEFAULTS.lang[MarkersListButton.id] = "Markers list";
registerButton(MarkersButton, "caption:left");
registerButton(MarkersListButton, "caption:left");
export { MarkersPlugin, events_exports as events };
//# sourceMappingURL=index.module.js.map
